export default "__VITE_ASSET__arUPZgNb__"